module.exports = __webpack_public_path__ + "static/media/afternoon-icon.a6a3be42.svg";